import BaseService from "@/services/BaseService";

export default class CoveragePlanService extends BaseService {
  constructor() {
    super('odoo/coverage');
  }

  findAllByCoverageId(coverageId, data) {
    return this.http.get(`${this._serviceName}/${coverageId}/plans`, { params: data });
  }

  save(coverageId, data) {
    return this.http.post(`${this._serviceName}/${coverageId}/plan`, data);
  }

  delete(coveragePlanId) {
    return this.http.delete(`${this._serviceName}/coverage-plan/${coveragePlanId}`)
  }

  update(id, descriptionId) {
    return this.http.put(`${this._serviceName}/coverage-plan/${id}/description/${descriptionId}`)
  }
}
